/** Protector Aluminium brand tokens carried over from app-housesigns. */
export const protector = {
    id: 'protector',
    name: 'Protector Aluminium',
    legalName: 'Protector Aluminium',
    websiteUrl: {
        au: 'https://www.protectoraluminium.com.au',
        nz: 'https://protectoraluminium.co.nz',
    },
    supportEmail: 'support@protectoraluminium.com.au',
    fonts: {
        heading: 'Outfit, Arial, sans-serif',
        body: 'Inter, Arial, sans-serif',
    },
    colors: {
        primary: {
            50: '#FEF3E8',
            100: '#FDE0C5',
            200: '#FBCB9E',
            300: '#F9B677',
            400: '#F79C49',
            500: '#F58220',
            600: '#D2691A',
            700: '#A55214',
            800: '#783C0F',
            900: '#4B2509',
        },
        primaryForeground: '#333333',
        primaryStrongForeground: '#FFFFFF',
        progress: '#F47920',
        accent: '#0D5257',
        headerBg: '#F58220',
        footerBg: '#F58220',
        plannerPageBg: '#F5F4F2',
        pageBg: '#FFFFFF',
        text: '#333333',
    },
    logos: {
        header: '/brands/protector/logo-prototype-v1.png',
        footer: '/brands/protector/logo-prototype-v1.png',
        favicon: '/brands/protector/favicon.svg',
        email: '/brands/protector/logo-email.svg',
    },
    admin: {
        fonts: {
            heading: 'Roboto, Arial, sans-serif',
            body: 'Roboto, Arial, sans-serif',
        },
        logos: {
            header: '/brands/protector/logo-header.svg',
            footer: '/brands/protector/logo-footer.svg',
        },
    },
    copy: {
        tagline: 'Built to last',
        footerLine: 'Protector Aluminium — quality Australian products',
        emailSignoff: 'The Protector Aluminium team',
    },
    social: {
        facebook: 'https://www.facebook.com/protectoral',
        instagram: 'https://www.instagram.com/protectoral',
        youtube: 'https://www.youtube.com/protectoral',
        linkedin: 'https://www.linkedin.com/company/protectoral',
        pinterest: 'https://www.pinterest.com/protectoral',
    },
};
//# sourceMappingURL=protector.js.map